import { requestSuccessFailure } from 'utilities/constants';

export const PREFIX = 'GET_THEME';

const themeConstants = {
    ...requestSuccessFailure(PREFIX)
};

export default themeConstants;